import accessConfig from "../accessConfig/accessConfig";

export default {

    getModuleLinks: [
        {   // zarządzanie trasami
            id: 1,
            stopien: 1,
            nazwa: 'Trasy',
            skrot:'ZT',
            ikona:'fa fa-road',
            url: '/konfiguracja/zarzadzanie-trasami',
            role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami'),
            podlinki: [
                {
                    id: 11,
                    stopien: 2,
                    nazwa: 'Miejscowości',
                    url: '/konfiguracja/zarzadzanie-trasami/miejscowosci',
                    ikona: 'fa fa-map-marker',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami/miejscowosci'),
                },
                {
                    id: 12,
                    stopien: 2,
                    nazwa: 'Przystanki',
                    url: '/konfiguracja/zarzadzanie-trasami/przystanki',
                    ikona: 'fa fa-map-signs',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami/przystanki'),
                },
                {
                    id: 13,
                    stopien: 2,
                    nazwa: 'Trasy',
                    url: '/konfiguracja/zarzadzanie-trasami/trasy',
                    ikona: 'fa fa-road',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami/trasy'),
                },
                {
                    id: 14,
                    stopien: 2,
                    nazwa: 'Linie',
                    url: '/konfiguracja/zarzadzanie-trasami/linie',
                    ikona: 'fa fa-road',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami/linie'),
                },
                {
                    id: 15,
                    stopien: 2,
                    nazwa: 'Przystanki na trasie',
                    url: '/konfiguracja/zarzadzanie-trasami/przystanki-na-trasie',
                    ikona: 'fa fa-flag-checkered',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami/przystanki-na-trasie'),
                },
                {
                    id: 16,
                    stopien: 2,
                    nazwa: 'e-przystanki',
                    url: '/konfiguracja/zarzadzanie-trasami/eprzystanki',
                    ikona: 'fa fa-at',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-trasami/eprzystanki'),
                }
            ]
        },
        {   // zasoby
            id:2,
            stopien:1,
            nazwa:'Zasoby',
            skrot:'ZZ',
            ikona:'fa fa-cubes',
            url: '/konfiguracja/zarzadzanie-zasobami',
            role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-zasobami'),
            podlinki:[
                {
                    id: 21,
                    nazwa: 'Pojazdy',
                    url: '/konfiguracja/zarzadzanie-zasobami/pojazdy',
                    ikona: 'fa fa-bus',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-zasobami/pojazdy'),
                },
                {
                    id: 22,
                    nazwa: 'Kierowcy',
                    url: '/konfiguracja/zarzadzanie-zasobami/kierowcy',
                    ikona: 'fa fa-id-card-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-zasobami/kierowcy'),
                },
                {
                    id: 23,
                    nazwa: 'Ekipy',
                    url: '/konfiguracja/zarzadzanie-zasobami/ekipy',
                    ikona: 'fa fa-group',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-zasobami/ekipy'),
                }
            ]
        },
        {   // rozkład jazdy
            id: 3,
            stopien: 1,
            nazwa: 'Rozkład jazdy',
            skrot:'RJ',
            ikona:'fa fa-exchange',
            url: '/konfiguracja/rozklad-jazdy',
            role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy'),
            podlinki: [
                {
                    id: 31,
                    stopien: 2,
                    nazwa: 'Kalendarze',
                    url: '/konfiguracja/rozklad-jazdy/kalendarze',
                    ikona: 'fa fa-calendar',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/kalendarze'),
                },
                {
                    id: 32,
                    stopien: 2,
                    nazwa: 'Godziny startowe tras',
                    url: '/konfiguracja/rozklad-jazdy/godziny-startowe',
                    ikona: 'fa fa-clock-o',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/godziny-startowe'),
                },
                {
                    id: 33,
                    stopien: 2,
                    nazwa: 'Rozkład',
                    url: '/konfiguracja/rozklad-jazdy/rozklad',
                    ikona: 'fa fa-exchange',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/rozklad'),
                },
                {
                    id: 34,
                    nazwa: 'Obsada',
                    url: '/konfiguracja/rozklad-jazdy/obsada',
                    ikona: 'fa fa-cubes',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/obsada'),
                }
                ,
                {
                    id: 35,
                    stopien: 2,
                    nazwa: 'Sprawdź konfigurację',
                    url: '/konfiguracja/rozklad-jazdy/sprawdz',
                    ikona: 'fa fa-check',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/sprawdz'),
                },
                {
                    id: 36,
                    stopien: 2,
                    nazwa: 'Szukaj',
                    url: '/konfiguracja/rozklad-jazdy/szukaj',
                    ikona: 'fa fa-search',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/szukaj'),
                },
                {
                    id: 37,
                    stopien: 2,
                    nazwa: 'Lokalizacja busów',
                    url: '/konfiguracja/rozklad-jazdy/lokalizacja',
                    ikona: 'fa fa-bus',
                    role: accessConfig.checkAccessToUrl('/konfiguracja/rozklad-jazdy/lokalizacja'),
                },
            ]

        },
        {   // bilety
            id:4,
            stopien:1,
            nazwa:'Bilety',
            skrot:'ZB',
            ikona:'fa fa-ticket',
            url: '/konfiguracja/zarzadzanie-biletami',
            role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami'),
            podlinki:[
                {
                    id: 41,
                    nazwa: 'Dodaj jednorazowy',
                    url: '/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy',
                    ikona: 'fa fa-plus',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy'),
                },
                {
                    id: 42,
                    nazwa: 'Bilety jednorazowe',
                    url: '/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe',
                    ikona: 'fa fa-ticket',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/bilety-jednorazowe'),
                },
                {
                    id: 43,
                    nazwa: 'Dodaj miesieczny',
                    url: '/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny',
                    ikona: 'fa fa-calendar-plus-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny'),
                },
                {
                    id: 44,
                    nazwa: 'Bilety miesięczne',
                    url: '/konfiguracja/zarzadzanie-biletami/bilety-miesieczne',
                    ikona: 'fa fa-calendar-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/bilety-miesieczne'),
                },
                {
                    id: 45,
                    nazwa: 'Faktury',
                    url: '/konfiguracja/zarzadzanie-biletami/faktury',
                    ikona: 'fa fa-credit-card',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/faktury'),
                },
                {
                    id: 46,
                    nazwa: 'e-płatności',
                    url: '/konfiguracja/zarzadzanie-biletami/eplatnosci',
                    ikona: 'fa fa-credit-card',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/eplatnosci'),
                },
                {
                    id: 47,
                    nazwa: 'Ceny biletów',
                    url: '/konfiguracja/zarzadzanie-biletami/ceny-biletow',
                    ikona: 'fa fa-money',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/ceny-biletow'),
                },
                {
                    id: 48,
                    nazwa: 'Zniżki',
                    url: '/konfiguracja/zarzadzanie-biletami/znizki',
                    ikona: 'fa fa-percent',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/znizki'),
                    dok: ''
                },
                {
                    id: 49,
                    nazwa: 'Promocje',
                    url: '/konfiguracja/zarzadzanie-biletami/promocje',
                    ikona: 'fa fa-tags',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-biletami/promocje'),
                }
            ]
        },
        {   // klienci
            id:5,
            stopien:1,
            nazwa:'Klienci',
            skrot:'ZK',
            ikona:'fa fa-group',
            url: '/zarzadzanie-klientami',
            role: accessConfig.checkAccessToUrl('/zarzadzanie-klientami'),
            podlinki:[
                {
                    id: 51,
                    nazwa: 'Karty',
                    url: '/konfiguracja/zarzadzanie-klientami/karty',
                    ikona: 'fa fa-address-card',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/zarzadzanie-klientami/karty'),
                },
                {
                    id: 52,
                    nazwa: 'Klienci',
                    url: '/zarzadzanie-klientami/klienci',
                    ikona: 'glyphicon glyphicon-user',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-klientami/klienci'),
                },
                {
                    id: 53,
                    nazwa: 'Firmy',
                    url: '/zarzadzanie-klientami/firmy',
                    ikona: 'fa fa-building-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-klientami/firmy'),
                },
                {
                    id: 54,
                    nazwa: 'Oceny',
                    url: '/zarzadzanie-klientami/oceny',
                    ikona: 'fa fa-star-half-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-klientami/oceny'),
                },
                {
                    id: 55,
                    nazwa: 'eBOK',
                    url: '/zarzadzanie-klientami/ebok',
                    ikona: 'fa fa-comments-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-klientami/ebok'),
                },
                {
                    id: 56,
                    nazwa: 'Eventy',
                    url: '/zarzadzanie-klientami/eventy',
                    ikona: 'fa fa-star',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-klientami/eventy'),
                },
            ]
        },
        {   // wynajem
            id:6,
            stopien:1,
            nazwa:'Wynajem',
            skrot:'ZW',
            ikona:'fa fa-list',
            url: '/konfiguracja/wynajem',
            role: accessConfig.checkAccessToUrl('/konfiguracja/wynajem'),
            podlinki:[
                {
                    id: 61,
                    nazwa: 'Lista',
                    url: '/konfiguracja/wynajem/lista',
                    ikona: 'fa fa-list',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/wynajem/lista'),
                },
                {
                    id: 62,
                    nazwa: 'Kalendarz',
                    url: '/konfiguracja/wynajem/kalendarz',
                    ikona: 'fa fa-calendar',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/konfiguracja/wynajem/kalendarz'),
                }
            ]
        },
        {   // komunikaty
            id:7,
            stopien:1,
            nazwa:'Komunikaty',
            skrot:'ZKO',
            ikona:'fa fa-send',
            url: '/zarzadzanie-komunikatami',
            role: accessConfig.checkAccessToUrl('/zarzadzanie-komunikatami'),
            podlinki:[
                {
                    id: 71,
                    nazwa: 'Powiadomienia',
                    url: '/zarzadzanie-komunikatami/powiadomienia',
                    ikona: 'fa fa-comments-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-komunikatami/powiadomienia'),
                },
                {
                    id: 72,
                    nazwa: 'Newsletter',
                    url: 'http://mailing.marcel-bus.pl/',
                    ikona: 'fa fa-envelope',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/zarzadzanie-komunikatami/newsletter'),
                }
            ]
        },
        {   // raporty
            id:8,
            stopien:1,
            nazwa:'Raporty',
            skrot:'RR',
            ikona:'fa fa-bar-chart',
            url: '/raporty',
            role: accessConfig.checkAccessToUrl('/raporty'),
            podlinki:[
                {
                    id: 81,
                    nazwa: 'Raport zapełnienia',
                    url: '/raporty/raport-zapelnienia',
                    ikona: 'fa fa-bar-chart',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/raport-zapelnienia'),
                },
                {
                    id: 82,
                    nazwa: 'Sprzedaż jedn. per trasa',
                    url: '/raporty/sprzedaz-jednorazowych',
                    ikona: 'fa fa-bar-chart',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/sprzedaz-jednorazowych'),
                },
                {
                    id: 83,
                    nazwa: 'Sprzedaż jedn. per linia',
                    url: '/raporty/sprzedaz-jedn-linie',
                    ikona: 'fa fa-bar-chart',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/sprzedaz-jedn-linie'),
                },
                {
                    id: 84,
                    nazwa: 'Sprzedaż miesięcznych',
                    url: '/raporty/sprzedaz-miesiecznych',
                    ikona: 'fa fa-area-chart',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/sprzedaz-miesiecznych'),
                },
                {
                    id: 85,
                    nazwa: 'Sprzedaż mies. per linia',
                    url: '/raporty/sprzedaz-mies-linie',
                    ikona: 'fa fa-area-chart',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/sprzedaz-mies-linie'),
                },
                {
                    id: 86,
                    nazwa: 'Rozliczenie kursów',
                    url: '/raporty/rozliczenie-kursow',
                    ikona: 'fa fa-calculator',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/rozliczenie-kursow'),
                },
                {
                    id: 87,
                    nazwa: 'Rozliczenia kierowców',
                    url: '/raporty/rozliczenia-kierowcow',
                    ikona: 'fa fa-calculator',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/rozliczenia-kierowcow'),
                },
                {
                    id: 88,
                    nazwa: 'Rozliczenia Orlen',
                    url: '/raporty/orlen',
                    ikona: 'fa fa-calculator',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/orlen'),
                },
                {
                    id: 89,
                    nazwa: 'Raport księgowość',
                    url: '/raporty/ksiegowosc',
                    ikona: 'fa fa-calculator',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/raporty/ksiegowosc'),
                }
            ]
        },
        {   // administracja
            id:9,
            stopien:1,
            nazwa:'Administracja',
            skrot:'AD',
            ikona:'fa fa-cogs',
            url: '/administracja',
            role: accessConfig.checkAccessToUrl('/administracja'),
            podlinki:[
                {
                    id: 91,
                    nazwa: 'Szablony',
                    url: '/administracja/szablony',
                    ikona: 'fa fa-file',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/szablony'),
                },
                {
                    id: 92,
                    nazwa: 'Przeglądarka plików',
                    url: '/administracja/przegladarka',
                    ikona: 'fa fa-file',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/przegladarka'),
                },/*
                {
                    id: 81,
                    nazwa: 'Faktury',
                    url: '/administracja/faktury',
                    ikona: 'fa fa-file',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/faktury'),
                },*/
                {
                    id: 93,
                    nazwa: 'Dostep',
                    url: '/administracja/dostep',
                    ikona: 'fa fa-key',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/dostep'),
                },
                {
                    id: 94,
                    nazwa: 'Pracownicy',
                    url: '/administracja/pracownicy',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/pracownicy'),
                },
                {
                    id: 95,
                    nazwa: 'Konfiguracja',
                    url: '/administracja/konfiguracja',
                    ikona: 'fa fa-cogs',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/konfiguracja'),
                },
                {
                    id: 96,
                    nazwa: 'Synchronizacja',
                    url: '/administracja/synchronizacja',
                    ikona: 'fa fa-refresh',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/synchronizacja'),
                },
                {
                    id: 97,
                    nazwa: 'Kierowca serwis',
                    url: '/administracja/kierowca-serwis',
                    ikona: 'fa fa-refresh',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/kierowca-serwis'),
                },
                {
                    id: 98,
                    nazwa: 'Logi aplikacji',
                    url: '/administracja/logi',
                    ikona: 'fa fa-refresh',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/administracja/logi'),
                }
            ]
        },
        {   // urzad
            id:10,
            stopien:1,
            nazwa:'Urząd',
            skrot:'UR',
            ikona:'fa fa-university',
            url: '/urzad',
            role: accessConfig.checkAccessToUrl('/urzad'),
            podlinki:[
                {
                    id: 101,
                    nazwa: 'Rozkład jazdy',
                    url: '/urzad/rozklad',
                    ikona: 'fa fa-file',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/rozklad'),
                },
                {
                    id: 102,
                    nazwa: 'Bilety jednorazowe',
                    url: '/urzad/jednorazowe',
                    ikona: 'fa fa-key',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/jednorazowe'),
                },
                {
                    id: 103,
                    nazwa: 'Bilety miesięczne',
                    url: '/urzad/miesieczne',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/miesieczne'),
                },
                {
                    id: 104,
                    nazwa: 'Raport cenników',
                    url: '/urzad/raport-cenniki',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/raport-cenniki'),
                },
                {
                    id: 105,
                    nazwa: 'Raport biletów',
                    url: '/urzad/raport-linie',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/raport-linie'),
                },
                {
                    id: 106,
                    nazwa: 'Raport sumaryczny lini',
                    url: '/urzad/raport-sumaryczny',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/raport-sumaryczny'),
                },
                {
                    id: 107,
                    nazwa: 'Raport dopłat grup',
                    url: '/urzad/raport-doplat-grup',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/raport-doplat-grup'),
                },
                {
                    id: 108,
                    nazwa: 'Raport dopłat suma',
                    url: '/urzad/raport-doplat-suma',
                    ikona: 'fa fa-id-badge',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/urzad/raport-doplat-suma'),
                },
            ]
        },
        {   // aplikacje
            id:11,
            stopien:1,
            nazwa:'Apl. Android',
            skrot:'AA',
            ikona:'fa fa-android',
            url: '/aplikacjeandroid',
            role: accessConfig.checkAccessToUrl('/aplikacjeandroid'),
            podlinki:[
                {
                    id: 111,
                    nazwa: 'Aplikacja eBus Driver',
                    url: '/aplikacjeandroid/ebus-driver',
                    ikona: 'fa fa-file',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/aplikacjeandroid/ebus-driver'),
                },
                {
                    id: 112,
                    nazwa: 'Aplikacja dla klientów',
                    url: '/aplikacjeandroid/aplikacja-kliencka',
                    ikona: 'fa fa-key',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/aplikacjeandroid/aplikacja-kliencka'),
                },

            ]
        },
        {   // LPP
            id:12,
            stopien:1,
            nazwa:'LPP',
            skrot:'lpp',
            ikona:'fa fa-id-card-o',
            url: '/lpp',
            role: accessConfig.checkAccessToUrl('/lpp'),
            podlinki:[
                {
                    id: 121,
                    nazwa: 'Odbicia',
                    url: '/lpp/odbicia',
                    ikona: 'fa fa-id-card-o',
                    stopien: 2,
                    role: accessConfig.checkAccessToUrl('/lpp/odbicia'),
                },
                // {
                //     id: 112,
                //     nazwa: 'Aplikacja dla klientów',
                //     url: '/aplikacjeandroid/aplikacja-kliencka',
                //     ikona: 'fa fa-key',
                //     stopien: 2,
                //     role: accessConfig.checkAccessToUrl('/aplikacjeandroid/aplikacja-kliencka'),
                // },

            ]
        },

    ],

}


















// WEBPACK FOOTER //
// ./src/utilities/linksConfig/Links.js